<!--table starts-->

<div class="subheader with-padding flgrow">
  <div class="row">
    <div class="col-lg-3 col-md-6 col-sm-8">
      <div class="flmid relative">
        <div class="input-group flgrow">
          <input class="form-control" type="text" name="searchTerm"
            placeholder="{{ 'lblSearchByServiceCategory' | translate }}" [(ngModel)]="pService.searchTerm"
            autocomplete="off" />
          <div class="input-group-append">
            <button type="button" class="btn btn-primary">
              <em class="fa fa-search"></em>
            </button>
          </div>
        </div>
      </div>

    </div>
    <div class="col-auto ml-auto" *ngIf="userRoleRightsDetails.canAdd">
      <button type="button" (click)="onAdd()" aria-label="Center Align" type="reset" class="add-button btn btn-primary mr-sm-2"
        translate>lblAddServiceCategory</button>
    </div>
  </div>
</div>

<div class="container prel">
  <div class="row">
    <div class="c12">
      <div class="card mb-3">
        <div class="card-header d-flex" translate>
          lblServiceCategory


        </div>
        <div class="table-responsive">
          <table class="tablest1">
            <thead>
              <tr>
                <th style="width: 55px" scope="col">#</th>
                <th style="width: 150px" scope="col" translate>lblLogo</th>
                <th scope="col" sortable="service" (sort)="onSort($event)" translate>lblServiceCategory</th>
                <th class="text-center" scope="col" translate>lblOrderNumber</th>
                <th style="width: 120px" class="text-center" scope="col" translate>lblAction</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="serviceCategories?.length>0; else load_else">
                <tr *ngFor="let service of serviceCategories; let i=index">
                  <td>{{ service.rowNumber }}</td>
                  <td>
                    <div class="imgWid">
                        <img af-image [data-code]="service.logo" [attr.alt]="service.name" width="70px">
                    </div>
                  </td>
                  <td>
                    <ngb-highlight [result]="service.service" [term]="pService.searchTerm"></ngb-highlight>
                  </td>

                  <td class="text-center">
                    {{service.orderNumber}}
                  </td>
                  <td class="nowrap text-center">
                    <a ngbTooltip="{{'lblEdit' | translate}}" tooltipClass="custom-revert" *ngIf="userRoleRightsDetails.canEdit"
                      (click)="gotoEdit(service.id)" class="btn btn-ico">
                      <em class="fas fa-pencil-alt fa-lg"></em>
                    </a>
                    <span class="ico-div" *ngIf="userRoleRightsDetails.canDelete"></span>
                    <a ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert" *ngIf="userRoleRightsDetails.canDelete"
                      (click)="deleteServiceCategory(service.id)" class="btn btn-ico">
                      <em class="far fa-trash-alt fa-lg"></em>
                    </a>

                  </td>
                </tr>
              </ng-container>
              <ng-template #load_else>
                <tr>
                  <td colspan="7" class="no-record" translate>lblNoRecordsFound</td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
        <div class="card-footer">
          <div class="d-flex justify-content-between">
            <div class="d-flex justify-content-between">
              <ngb-pagination [collectionSize]="pService.total$  | async" [(page)]="pService.page"
                [pageSize]="pService.pageSize" [maxSize]="3">
              </ngb-pagination>
              <select class="custom-select mx-2" style="width: auto" name="pageSize" [(ngModel)]="pService.pageSize">
                <option *ngFor="let item of pService.pageItemsArray" [ngValue]="item.values" translate>{{item.label}}
                </option>
              </select>
            </div>
            <div class="d-flex justify-content-between p-2 font17 fontbold" style="margin: auto 0;">
              <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{pService.total$ | async}}&nbsp;<span
                class="font17 fontnormal" translate>lblResults</span>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>